/* ZayOnline: block auto-open, refresh drawer, then open */
(function () {
  console.log('[Zay] quick-add loaded');

  // Section handles & selectors (adjust if different)
  const DRAWER_SECTION = 'cart-drawer';         // Eurus drawer section file exists in your theme
  const DRAWER_MOUNTS  = ['#shopify-section-cart-drawer', '#CartDrawer', '#cart-drawer', '[data-section-id="cart-drawer"]', '.cart-drawer'];
  const OPEN_TRIGGERS  = ['[data-open-cart-drawer]', '[data-cart-trigger]', 'button[name="open-cart"]', 'button[data-action="open-cart"]'];
  const CLOSE_TRIGGERS = ['[data-close-cart-drawer]', '[data-drawer-close]', '.cart-drawer__close', 'button[aria-label="Close cart"]'];

  let lockAutoOpen = false;

  // TEMPORARILY block any click that tries to open the drawer while we refresh it
  document.addEventListener('click', function (e) {
    if (!lockAutoOpen) return;
    if (OPEN_TRIGGERS.some(sel => e.target.closest(sel))) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);

  document.addEventListener('click', onClick, true);
  document.addEventListener('submit', onSubmit, true);

  function onClick(e) {
    const btn = e.target.closest('.mmc-card-atc_btn');
    if (!btn) return;
    const form = btn.closest('form.mmc-card-atc');
    if (!form) return;
    e.preventDefault();
    addAndRefresh(form);
  }

  function onSubmit(e) {
    const form = e.target.closest('form.mmc-card-atc');
    if (!form) return;
    e.preventDefault();
    addAndRefresh(form);
  }

  function addAndRefresh(form) {
    const fd = new FormData(form);
    if (!fd.get('id')) return;

    lockAutoOpen = true;   // block theme’s instant drawer open

    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(r => r.ok ? r.json() : r.text().then(Promise.reject))
      .then(() => refreshDrawerHTML())
      .then(() => openDrawer())
      .then(() => flashAdded(form))
      .catch(err => { console.error('[Zay] add/refresh error:', err); })
      .finally(() => { lockAutoOpen = false; });
  }

  function refreshDrawerHTML() {
    // Close immediately if theme already popped it open empty
    closeDrawer();

    // Fetch fresh drawer HTML directly by section_id
    return fetch(`/?section_id=${DRAWER_SECTION}`, { headers: { 'Accept': 'text/html' } })
      .then(r => r.text())
      .then(html => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        const incoming = tmp.firstElementChild;
        if (!incoming) return;

        for (const sel of DRAWER_MOUNTS) {
          const mount = document.querySelector(sel);
          if (mount) { 
  mount.outerHTML = incoming.outerHTML; 
  addFadeClass();          // <-- add this line
  break; 
}
        }

        // Update cart count too
        return fetch('/cart.js').then(r => r.json()).then(cart => {
          document.querySelectorAll('[data-cart-count],[data-cart-count-bubble]').forEach(el => el.textContent = cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        });
      });
  }

  function openDrawer() {
    // Click the theme’s open trigger
    for (const sel of OPEN_TRIGGERS) {
      const btn = document.querySelector(sel);
      if (btn) { btn.click(); return; }
    }
    // Fallback: add common open class
    const drawer = document.querySelector('#CartDrawer,.cart-drawer,[data-cart-drawer]');
    if (drawer && !drawer.classList.contains('is-open')) drawer.classList.add('is-open');
  }

  function closeDrawer() {
    for (const sel of CLOSE_TRIGGERS) {
      const btn = document.querySelector(sel);
      if (btn) { btn.click(); return; }
    }
    const drawer = document.querySelector('#CartDrawer,.cart-drawer,[data-cart-drawer]');
    if (drawer && drawer.classList.contains('is-open')) drawer.classList.remove('is-open');
  }

  function flashAdded(form) {
    const btn = form.querySelector('.mmc-card-atc_btn');
    if (!btn) return;
    const old = btn.textContent;
    btn.disabled = true; btn.textContent = 'Added ✓';
    setTimeout(() => { btn.disabled = false; btn.textContent = old; }, 1200);
  }

  function addFadeClass() {
  const drawer = document.querySelector('#CartDrawer,.cart-drawer,[data-cart-drawer]');
  if (drawer) drawer.classList.add('zay-fade');

  const overlay = document.querySelector('.cart-drawer__overlay,[data-cart-overlay]');
  if (overlay) overlay.classList.add('zay-fade');
}

})();


